import { useState } from "react";
import { useSearchQueries } from "@radarly/core/queries/use-cases";
import { useCurrentUserLocale } from "@radarly/core/user/use-cases";

export function useSwitcherSearchQueries(search: string) {
  const [includeQueryBody, setIncludeQueryBody] = useState(false);
  const [includeLabel, setIncludeLabel] = useState(true);
  const { queries, loading, fetchMore, canFetchMore } = useSearchQueries(
    search,
    {
      includeQueryBody,
      includeLabel,
    }
  );
  const toggleIncludeLabel = () => {
    setIncludeLabel(!includeLabel);
  };
  const toggleIncludeQueryBody = () => {
    setIncludeQueryBody(!includeQueryBody);
  };
  const locale = useCurrentUserLocale();
  return {
    includeQueryBody,
    toggleIncludeQueryBody,
    includeLabel,
    toggleIncludeLabel,
    loading,
    queries,
    fetchMore,
    canFetchMore,
    locale,
  };
}
